<template>
  <div class="mergs-navbar g-flex-sb">
    <div class="g-flex-sb btn-width">
      <!-- <h3 :class="{'active bottom': menuType === undefined}" @click="toggleMenu(undefined)">商户后台</h3>
      <h3  v-if="hasMarketRight" :class="{'active bottom': menuType === 'shop'}" @click="toggleMenu('shop')">能＋营销</h3>
      <h3  v-if="showSupply" v-loading="isLoading" class="mergs-active-title" @click="handleChainToken">一键叫油</h3> -->
    </div>
    <div class="g-flex-sb">
      <!-- <div class="ads realtion" @click="ruleCenter">
        <span>规则中心</span>
      </div> -->
      <template v-if="!isSdLogin">
        <el-dropdown v-if="!isHbgsLogin" @command="ruleCenter">
          <div class="el-dropdown-link ads realtion">
            规则中心<i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="basicsRule">基础规则</el-dropdown-item>
            <el-dropdown-item command='violation'>油站质量分</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <div class="ads realtion" @click="oilStudy">
          <img class="top-icon" src="../../../assets/image/top/school.png" alt="">
          <span>油站学堂</span>
        </div> -->
        <div v-if="!isHbgsLogin" class="ads realtion" @click="drawerApi">
          <img class="top-icon" src="../../../assets/image/top/connectUs.png" alt="">
          <span>联系我们</span>
        </div>
        <el-popover
          width="350"
          trigger="hover">
          <div class="mergs-pop-container">
            <p class="pop-title">关注团油商户通，下载语音助手，让你流水轻松翻倍！</p>
            <div class="g-flex-c">
              <div>
                <img class="qrcode" src="https://web.nlktj.com/ty/merchant/image/qrcode/app1.png" alt="">
                <div>团油商户通</div>
              </div>
              <div style="margin-left: 15px">
                <img class="qrcode" src="https://web.nlktj.com/ty/merchant/image/qrcode/voice1.png" alt="">
                <div>团油语音助手</div>
              </div>
            </div>
          </div>
          <div v-if="!isHbgsLogin" class="ads" style="cursor: pointer;" slot="reference">
            <img class="top-icon" src="../../../assets/image/top/merchantApp.png" alt="">
            <!-- 点击流水翻倍 -->
            商户终端
          </div>
        </el-popover>
      </template>
      <div v-has="'waitInfo'" class="ads info" style="cursor: pointer;" @click="handleToInfo"><img src="../../../assets/image/top/message.png" alt=""><span>消息中心</span><span v-if="infoNum > 0" class="num">{{infoNum > 99 ? '99+' : infoNum }}</span></div>
      <el-popover
        popper-class="mergs-user-pop"
        placement="bottom-end"
        trigger="hover"
        :visible-arrow="false">
        <div class="mergs-content">
          <div class="top-wrapper">
            <div class="top-left">
              <div class="name">{{userInfo.userName || '团油用户'}}</div>
              <!-- <div class="withdraw" v-if="hasFundType" @click="handleCommand('gotoMarketFund')">营销基金</div> -->
            </div>
            <div class="company">{{userInfo.company ? `商户/${userInfo.companyName}` : `油站/${userInfo.gasName}`}}</div>
          </div>
          <div class="btn-wrap">
            <div @click="handleCommand('gotoMyAccount')" class="my-account" type="primary">我的账号</div>
            <div @click="handleCommand('handleLogout')" class="logout">退出登录</div>
          </div>
        </div>
        <div class="el-dropdown-link" slot="reference">
          <img class="avatar" :src="ossUrl + `${avantar}`" alt="">
          <div class="username-wrap">
            <span class="username">{{userInfo.userName || '团油用户'}}</span>
            <span class="company eli">{{userInfo.company ? `商户/${userInfo.companyName}` : `油站/${userInfo.gasName}`}}</span>
          </div>
        </div>
      </el-popover>
      <el-popover
        v-if="userInfo.multipleAccounts"
        popper-class="mergs-account-pop"
        placement="bottom-end"
        trigger="click"
        :visible-arrow="false">
        <div class="mergs-account-content" v-loading="isAccountLoading">
          <div class="mergs-account-item" v-for="(item, index) in accountList" :key="index" @click="switchAccount(item)" :class="{active: item.userId === userInfo.userId}" >
            <span class="username">{{item.userName || '团油用户'}}</span>
            <span class="company eli">{{item.dataAuthorityTypeName + '/' + item.dataAuthorityName}}</span>
          </div>
        </div>
        <div class="check-acccount" slot="reference" @click="getAccountList">切换账号</div>
      </el-popover>
    </div>
    <!-- 营销基金提醒 -->
    <notification :isShow.sync="isShow" @closeNotifi="closeNotifi" v-if="showNotifi" :noticeObj="noticeObj"></notification>
    <el-drawer
      size="20%"
      title="联系我们"
      :visible.sync="drawer"
      :modal="false">
      <ul class="drawer-ul">
        <li class="customer">客服电话</li>
        <li class="phone g-flex-center-start"><img :src="imgPhone" alt=""><span>400-0063-888</span></li>
        <li class="time">每天8:00 ~ 22:00</li>
        <template v-if="!userInfo.company">
          <li class="manage">业务经理</li>
          <li class="phone g-flex-center-start"><img :src="imHeader" alt=""><span>{{contractorName}}</span></li>
          <li class="phone g-flex-center-start"><img :src="imgPhone" alt=""><span>{{contractorPhone}}</span></li>
        </template>
      </ul>
    </el-drawer>
  </div>
</template>

<script>
import { mapState, mapGetters ,mapActions } from 'vuex'
import { getAccountType, getNoticeList } from '@/api/marketFund'
import { getChainToken, getShowSupply } from '@/api/chain'
import notification from '@/components/work/notification'
import { getAccountList, loginByPhone } from '@/api/login'
import { ossUrl }  from '@/utils/config'
import { getGasContractorInfo, registerAndLoginXet } from '@/api/common'
export default {
  name: 'navbar',
  components: {
    notification
  },
  data () {
    return {
      imgPhone: 'https://web.nlktj.com/ty/czb-merchant-web/images/customer/phone.png',
      imHeader: 'https://web.nlktj.com/ty/czb-merchant-web/images/customer/header.png',
      drawer: false, // 抽屉，联系我们
      noticeObj: { // 展示当前右下角营销基金提示消息
        noticeTitle: '',
        noticeContent: '',
        gasId: '',
        noticeId: ''
      },
      noticeList: [], // 当前账号下存在余额不足的油站消息列表
      showNotifi: false,
      isShow: false, // 展示营销基金提醒
      isAccountLoading: false,
      // isLoadingMutiple: false,
      isLoading: false, // 获取token loading
      accountList: [], // 账号列表
      ossUrl,
      showSupply: false, // 是否展示一键叫油入口
      visible: false,
      hasChain: false, // 是否有供应链权限
      showMarket: false, // 是否开户
      contractorName: '', // 客服经理
      contractorPhone: '', // 客服电话
      // isSdLogin: false,
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo,
      hasFund: state => state.permission.hasFund,
      infoNum: state => state.infoAll.infoNum,
    }),
    ...mapGetters(['menuType', 'hasMarketRight', 'isSdLogin', 'isHbgsLogin']),
    hasFundType () {
      const { hasFund, showMarket } = this
      return hasFund && showMarket
    },
    avantar () {
      // ? 'shunda_avantar.png' : 'newlink-avatar1.png'
      if (this.isSdLogin) {
        return 'shunda_avantar.png'
      } else if (this.isHbgsLogin) {
        return 'hebeigaosu_avantar.png'
      } else {
        return 'newlink-avatar1.png'
      }
    }
  },
  watch: {
    '$route' (e) {
      this.changeMenu(e.matched.some(item => item.meta.type === 'shop') ? 'shop' : undefined)
      this.isShow = e.matched.some(item => item.meta.type === 'shop') || e.path === '/fund/marketFund'
    }
  },
  mounted () {
    // this.isSdLogin = JSON.parse(sessionStorage.getItem('isSdLogin'))
    this.getNoticeList()
    this.changeMenu(this.$route.matched.some(item => item.meta.type === 'shop') ? 'shop' : undefined)
    this.isShow = this.$route.matched.some(item => item.meta.type === 'shop') || this.$route.path === '/fund/marketFund'
    this.getAccountType()
    this.getShowSupply()
    this.getGasContractorInfoApi()
  },
  methods: {
    ...mapActions('permission', ['changeMenu']),
    handleCommand (command) {
      this[command]()
    },
    handleLogout () {
      this.$confirm('请确认是否退出当前登录账号', '退出账号', {
        confirmButtonClass: 'mergs-btn-true',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.logout()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 抽屉
    drawerApi () {
      this.drawer = true
    },
    async logout () {
      await this.$store.dispatch('user/clearInfo')
      this.$store.dispatch('permission/resetPermission')
    },
    toggleMenu (type) {
      type ? this.$router.push({ path: '/home/index' }) : this.$router.push({ path: '/customer/workPlatform' })
      setTimeout(() => {
        this.$parent.changeMenuType()
      }, 300)
    },
    gotoMyAccount () {
      this.$router.push({ name: 'myAccount' })
    },
    gotoMarketFund () {
      this.$track.clickEvent('营销基金-我的账号', 1624962181)
      this.$router.push({ name: 'marketFund' })
    },
    // 跳转到消息中心列表
    handleToInfo () {
      this.$track.clickEvent('PC首页-顶部消息中心按钮', '1628492241')
      this.$router.push({ path: '/merchant/messageManage' })
    },
    // 规则中心跳转
    ruleCenter (path) {
      console.log(path)
      this.$track.clickEvent('团油商家端顶部-规则中心按钮', '1657274210')
      this.$router.push({ path: `/ruleCenter/${path}` })
    },
    // 油站学堂,跳转第三方链接。
    async oilStudy () {
      this.$track.clickEvent('商户PC首页-顶部学堂入口按钮', '1628494910')
      try {
        const { code, result } = await registerAndLoginXet({ userId: this.userInfo.userId })
        if (code !== 200) return
        window.open(result.data.login_url)
      } catch (error) {
        console.log(error)
      }
    },
    // 获取直供入口权限
    async getShowSupply () {
      try {
        const { code, result } = await getShowSupply()
        if (code !== 200) return
        this.showSupply = result.showSupply
      } catch (error) {
        console.log(error.message)
      }
    },
    // 判断是否开户
    async getAccountType () {
      try {
        const { code, result } = await getAccountType()
        if (code !== 200) return
        if (!['null', '[]'].includes(JSON.stringify(result))) {
          this.showMarket = true
        }
      } catch (error) {
        console.log(error.message)
      }
    },
    // 处理能链直供系统token
    handleChainToken () {
      this.getChainToken()
    },
    async getChainToken () {
      try {
        this.isLoading = true
        const { code, result } = await getChainToken()
        if (code !== 200) return
        this.gotoChainSystem(result)
      } catch (error) {
        console.log(error.message)
      } finally {
        this.isLoading = false
      }
    },
    // 跳转至能链直供系统
    gotoChainSystem (token) {
      window.location.href = `${process.env.VUE_APP_SUPPLY_URL}?token=${token}&hasMarketRight=${Number(this.hasMarketRight)}`
    },
    // 关闭营销基金提醒(如果存在多个)
    closeNotifi ({ noticeId, type }) {
      if (!type) {
        this.noticeList.length = 0
        this.showNotifi = this.isShow = false
        return
      }
      let index = this.noticeList.findIndex(item => item.noticeId === noticeId)
      if (index !== -1) {
        this.noticeList.splice(index, 1)
      }
      this.noticeList.length ? (
        this.noticeObj = {...this.noticeList[0]},
        this.isShow = true
      ) : this.showNotifi = this.isShow = false
    },
    // 获取联系我们的电话
    async getGasContractorInfoApi () {
      try {
        const { code, result } = await getGasContractorInfo()
        if(code !== 200) return
        const { contractorName, contractorPhone } = result
        this.contractorName = contractorName
        this.contractorPhone = contractorPhone
      } catch (error) {
        console.log(error)
      }
    },
    // 获取账号下存在余额不足的油站消息列表
    async getNoticeList () {
      try {
        const { code, result } = await getNoticeList()
        if (code !== 200) return
        if (result?.length) {
          this.noticeList = result
          this.noticeObj = result[0]
          this.showNotifi = true
        } else {
          this.showNotifi = false
        }
      } catch (error) {
        console.log(error.message)
      }
    },
    // 获取账号列表
    async getAccountList () {
      try {
        this.isAccountLoading = true
        const { code, result } = await getAccountList()
        if (code !== 200) return
        this.accountList = result
      } catch (error) {
        console.log(error.message)
      } finally {
        this.isAccountLoading = false
      }
    },
    // 切换账号
    switchAccount (item) {
      if (this.userInfo.userId === item.userId) return
      this.$confirm('请确认是否切换当前登录账号', '切换账号', {
        confirmButtonClass: 'mergs-btn-true',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        const params = {
          mobile: this.userInfo.mobile,
          companyToken: item.companyToken
        }
        this.quietlyLogin(params)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 静默登录
    async quietlyLogin(params){
      try {
        const { code, result } = await loginByPhone(params)
        if (code !== 200) {
          this.logout()
          return
        }
        const { token, ...userInfo } = result
        await this.$store.dispatch('user/setTokenAndUserInfo', { token: token, auto: true, userInfo })
        this.$router.push({ path: '/' })
        location.reload()
      } catch (error) {
        console.log(error.message)
      }
    }
  }
}
</script>

<style lang="less">
.font {
  font-size: 13px;
  color: #222222;
}
.font-title{
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.no-wrap{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.flex-box{
  display: flex;
  justify-content: center;
  align-items: center;
}
.mergs-navbar {
  height: 63px;
  background: #fff;
  border-bottom: 1px solid #EEEEEE;
  padding-right: 30px;
  .font();
  .btn-width {
    // width: 240px;
    margin-left: 32px;
    cursor: pointer;
    position: relative;
    h3{
      position: relative;
      margin-right: 43px;
    }
    .active {
      color: #4B7EFE;
      &.bottom:after {
        content: '';
        position: absolute;
        bottom: -14px;
        top: auto;
        left: 22px;
        height: 3px;
        width: 20px;
        background-color: #4B7EFE;
      }
    }
  }
  .ads {
    margin-right: 30px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #222222;
    img {
      width: 20px;
      height: 20px;
      vertical-align: text-bottom;
      margin-right: 3px;
    }
  }
  .realtion{
    cursor: pointer;
    margin-right: 40px;
  }
}
.mergs-pop-container {
  text-align: center;
  .pop-title {
    font-size: 13px;
    color: #222222;
  }
  .qrcode {
    width: 140px;
    height: 140px;
  }
}
.el-dropdown-link {
  display: flex;
  align-items: center;
  .font-title();
  cursor: pointer;
  .avatar{
    width: 30px;
    height: 30px;
    vertical-align: middle;
    margin-right: 5px;
  }
  .username-wrap{
    display: flex;
    font-size: 14px;
    margin-right: 10px;
    .username{
      .no-wrap();
      color: #222222;
      margin-right: 10px;
    }
    .company{
      .no-wrap();
      color: #A7A7A7;
    }
  }
}

.mergs-account-pop{
  width: 380px!important;
  padding: 6px 31px 12px 32px!important;
  .font-title();
  .mergs-account-content{
    max-height: 179px;
    overflow-y: auto;
    .mergs-account-item{
      padding: 12px 0;
      box-sizing: border-box;
      border-bottom: 1px solid #F3F3F3;
      display: flex;
      align-items: center;
      cursor: pointer;
      &.active{
        .username{
          color: #4B7EFE;
        }
        .company{
          color: #4B7EFE;
        }
      }
      // &:last-child{
      //   border: none;
      // }
      .username{
        .no-wrap();
        width: 90px!important;
        // margin-right: 10px;
        color: #222222;
      }
      .company{
        flex: 1;
        .no-wrap();
        color: #A7A7A7;
      }
    }
  }
}
.check-acccount{
  .font-title();
  white-space: nowrap;
  color: #4B7EFE;
  cursor: pointer;
}

.mergs-user-pop{
  width: 324px!important;
  // height: 139px!important;

  .mergs-content{
    padding: 8px;
    .top-wrapper{
      margin-bottom: 21px;
      .top-left{
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
        .name{
          .font-title();
          color: #222222;
        }
        .withdraw{
          .no-wrap();
          width: 60px;
          height: 20px;
          border-radius: 2px;
          border: 1px solid #4B7EFE;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #4B7EFE;
          text-align: center;
          line-height: 20px;
          cursor: pointer;
        }
      }
      .company{
        .font-title();
        color: #A7A7A7;
      }
    }

    .btn-wrap{
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .font-title();
      .my-account{
        width: 122px;
        height: 40px;
        background: #4B7EFE;
        border-radius: 2px;
        color: #FFFFFF;
        margin-right: 10px;
        cursor: pointer;
        .flex-box();
      }
      .logout{
        width: 122px;
        height: 40px;
        background: #FFFFFF;
        border-radius: 2px;
        border: 1px solid #CCCCCC;
        color: #666666;
        cursor: pointer;
        .flex-box();
      }
    }
  }
}

.mergs-menu{
  font-size: 15px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: bold;
  color: #222222;
  &.actives{
    color: #4B7EFE;
      &.bottom {
        content: '';
        position: absolute;
        bottom: -14px;
        top: auto;
        left: 22px;
        height: 3px;
        width: 20px;
        background-color: #4B7EFE;
      }
  }

}
.mergs-gas-pop{
  top: 50px!important;
  // padding: 0!important;
  background: #FFFFFF!important;
  box-shadow: 0px 3px 11px 0px rgba(35,99,201,0.12)!important;
  border: 1px solid #E5E5E5!important;
  padding: 14px!important;
  .gas-list{
    max-height: 130px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      margin-left: -4px;
      width: 1px;
    }
    &::-webkit-scrollbar-thumb{
      background: rgba(0, 0, 0, 0.2);
      border-radius:1px;
    }
    .gas-item{
      margin-bottom: 10px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      &:last-child{
        margin-bottom: 0;
      }
      &:hover{
        color: #4B7EFE;
        cursor: pointer;
      }
    }
  }
}
.mergs-active-title{
  &:hover{
    color: #4B7EFE;
    cursor: pointer;
  }
}
.el-button--default.mergs-btn-true{
  background-color: #4B7EFE;
  border: none;
}
.eli{
  max-width: 250px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.info{
  padding: 4px;
  position: relative;
  .num{
    position: absolute;
    top: -7px;
    right: -11px;
    font-size: 12px;
    color: #fff;
    padding: 2px 6px;
    background: #E31937;
    // min-width: 30px;
    text-align: center;
    border-radius: 14px;
  }
}
.drawer-ul{
  list-style: none;
  margin: 0;
  padding: 0 20px;
  li{
    margin-top: 12px;
  }
  .customer{
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #222222;
  }
  .phone{
    >img{
      display: block;
      width: 20px;
      height: 20px;
    }
    span{
      margin-left: 10px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
    }
  }
  .time{
    margin-left: 30px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #6A6A6A;
  }
  .manage{
    margin-top: 50px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #222222;
  }
}
.el-drawer__header{
  font-size: 18px;
  font-weight: 900;
  color: #000;
  :focus {
    outline: none
  }
}
</style>
